// removed by extract-text-webpack-plugin
    if(module.hot) {
      // 1516227481848
      var cssReload = require("../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  


//////////////////
// WEBPACK FOOTER
// ./components/navbar/navbar.scss
// module id = 85
// module chunks = 0